/* eslint-disable prefer-rest-params */
export const pxInit = config => {
  window._pxAppId = config.pxId;
  const p = document.getElementsByTagName('script')[0];
  const head = document.getElementsByTagName('head')[0];
  const s = document.createElement('script');
  s.async = 1;
  s.src = `//client.perimeterx.net/${config.pxId}/main.min.js`;
  p ? p.parentNode.insertBefore(s, p) : head.appendChild(s);
};
